import { useMemo } from 'react';
import { formatStatus } from '../../utils/format-status.utils';
import { Chip, makeStyles } from '@material-ui/core';
import { OrderStatus } from '../../types/order-status.type';

const getChipStyle = (payment) => {
  switch (payment) {
    case 'abandoned':
      return { backgroundColor: '#f0f0f0', color: '#000000' }; // Light Grey
    case 'canceled':
      return { backgroundColor: '#f44336', color: '#ffffff' }; // Red
    case 'paid':
      return { backgroundColor: '#4caf50', color: '#ffffff' }; // Green
    case 'refuse':
      return { backgroundColor: '#ff9800', color: '#ffffff' }; // Orange
    case 'waiting':
      return { backgroundColor: '#2196f3', color: '#ffffff' }; // Blue
    case 'refund':
      return { backgroundColor: '#8e44ad', color: '#ffffff' }; // Dark Purple
    case 'partial':
      return { backgroundColor: '#f1c40f', color: '#000000' }; // Gold
    default:
      return { backgroundColor: '#f0f0f0', color: '#000000' }; // Light Grey
  }
};

interface StyleProps {
  color: string;
  backgroundColor: string;
}

interface Props {
  status: OrderStatus;
  size: 'small' | 'medium';
}

const useStyles = makeStyles(() => ({
  root: (props: StyleProps) => ({
    borderRadius: 4,
    textTransform: 'capitalize',
    backgroundColor: props.backgroundColor,
    color: props.color,
  }),
}));

export default function OrderStatusChip({ status, size }: Props) {
  const { label, backgroundColor, color } = useMemo(() => {
    return {
      label: formatStatus(status),
      ...getChipStyle(status),
    };
  }, [status]);

  const classes = useStyles({ backgroundColor, color });

  return <Chip className={classes.root} label={label} size={size} />;
}
